import { ApiUrl } from "../../ApiUrl"
export const fetchMessageTypes = async () => {
    try {
      const response = await fetch(`${ApiUrl.apiurl}MESSAGETYPE/GetAllMessageTypeList/`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      if (data.message === "Success") {
        return data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching message types:", error);
      return [];
    }
  };
  